<app-header></app-header>
<div class="row mt-4 ml-1 mr-1" >
  <div class="col">
    <ngx-spinner></ngx-spinner>
    <div class="cards">
      <div *ngFor="let pc of productCategories" class="card">
        <img src="{{baseUrl + pc.productCategoryImageName}}" class="card-img-top" alt="{{pc.productCategoryImageName}}"
          title="{{pc.productCategoryTitle}}">
        <div class="card-body">
          <h5 class="card-title">{{pc.productCategoryTitle}}</h5>
          <p class="card-text">{{pc.productCategoryDescription}}</p>
          <a class="stretched-link" [attr.href]="pc.productCategoryId == 5 
                         ? (('nomenclature/0/0/true/false') + '?name='+ encodeContent(pc.productCategoryTitle))
                         : (pc.productCategoryId == 6 ? 'nomenclature/0/0/false/true' 
                                                      : 'subcategory/'+ pc.productCategoryId) 
                           + '?name='+ encodeContent(pc.productCategoryTitle)" title="{{pc.productCategoryTitle}}"></a>
        </div>
      </div>
    </div>
  </div>
</div>